export default {
  app: {
    name: "Admin Console"
  }
};
const defaultValues = {
  shopId: 1
};

const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault"
};

const language = "persian";

const AlgoliaSearchConfig = {
  appId: "",
  apiKey: ""
};
const Auth0Config = {
  domain: "",
  clientID: "",
  allowedConnections: ["Username-Password-Authentication"],
  rememberLastLogin: true,
  language: "en",
  closable: true,
  options: {
    auth: {
      autoParseHash: true,
      redirect: true,
      redirectUrl: "http://localhost:3000/auth0loginCallback"
    },
    languageDictionary: {
      title: "پنل مدیریت فروشگاه",
      emailInputPlaceholder: "kooch@varanegar.com",
      passwordInputPlaceholder: "پنل مدیریت"
    },
    theme: {
      labeledSubmitButton: true,
      logo: "",
      primaryColor: "#E14615",
      authButtons: {
        connectionName: {
          displayName: "Log In",
          primaryColor: "#b7b7b7",
          foregroundColor: "#000000"
        }
      }
    }
  }
};

const firebaseConfig = {
  apiKey: "",
  authDomain: "",
  databaseURL: "",
  projectId: "",
  storageBucket: "",
  messagingSenderId: ""
};

const googleConfig = {
  apiKey: "AIzaSyC4yls3Qc7KbbBwQZ6zxgjwGDASGavc5EI" //
};

const mapboxConfig = {
  tileLayer: "",
  maxZoom: "",
  defaultZoom: "",
  center: []
};
export {
  themeConfig,
  language,
  AlgoliaSearchConfig,
  Auth0Config,
  firebaseConfig,
  googleConfig,
  mapboxConfig,
  defaultValues
};

export const toastConfig = {
  autoClose: 8000,
  draggable: false
};
